module.exports = __webpack_public_path__ + "static/media/Farinha.8413a959.png";